import React, { useState, useRef, useEffect, useContext, useMemo, forwardRef, useImperativeHandle } from 'react'
import { Card } from 'component'
import Pagination from 'baseComponent/pagination'
import MNWaterfallApi from 'component/waterfall/masonryApi'
import { Empty, Loading } from 'meinian-package/src/baseComponent'
import globalData from 'meinian-package/src/common/globalData'
import { Affix } from 'antd'
import SampleTable from '../sampleTable/index'
import { AccountContext } from '../../../../../context'
import { useClothings } from '../../hooks/useClothings'
import { SampleViewModel, VIEW_MODE } from '../../../../components/fixedOperation/sampleMode'
import { BatchTools } from '../batch'
import css from './index.module.less'

const VIEW_MODE_KEY = 'mn:newSampleList:viewMode'
function useViewMode(refresh) {
  const [viewMode, setViewMode] = useState(VIEW_MODE.PLAT)
  useEffect(() => {
    globalData.get(VIEW_MODE_KEY, setViewMode, 1)
  }, [])
  return {
    viewMode,
    component: <SampleViewModel
      style={{ right: 16, bottom: 114 }}
      viewMode={viewMode}
      onViewMode={(val) => {
        setViewMode(val)
        globalData.set(VIEW_MODE_KEY, val)
        refresh(val)
      }}
      className={undefined}
    />
  }
}

const EmptyText = () => {
  return (
    <>
      上传样衣到这里，可在线查看和管理样衣哦
    </>
  )
}
type Props = {
  params: any
  isBatch?: boolean
  onLoaded?:(total:number)=>void
  setIsBatch?: React.Dispatch<React.SetStateAction<boolean>>
  style?:React.CSSProperties
}
const SampleClothingList = forwardRef(
  ({ params, isBatch, setIsBatch, onLoaded, style }: Props, ref) => {
    const { userInfo = {}, teamInfo = {} } = useContext(AccountContext) as unknown as { userInfo: any; teamInfo: any }
    const [batchAll, setBatchAll] = useState([])
    const [pager, setPager] = useState({
      pageSize: 20,
      pageNo: 1,
    })
    const $masonry = useRef(null)
    const [tableSortParams, setTableSortParams] = useState({})
    const refresh = () => {
      if ($masonry.current) {
        $masonry.current?.init()
      } else {
        fetchData()
      }
    }

    const { component, viewMode } = useViewMode(refresh)

    const postParams = useMemo(() => {
      if (viewMode !== VIEW_MODE.COLUMN) return { ...pager, ...params }
      return { ...pager, ...params, ...tableSortParams }
    }, [pager, params, tableSortParams, viewMode])

    const { run: fetchData, data, loading } = useClothings(postParams, {
      manual: true,
      onSuccess(d) {
        setBatchAll(d.resultList)
        onLoaded?.(d.resultCount)
      }
    })

    useEffect(() => {
      if (viewMode !== VIEW_MODE.COLUMN) return
      fetchData()
    }, [params, pager.pageNo, tableSortParams])

    useEffect(() => {
      setIsBatch(false)
      setPager({ pageSize: 20, pageNo: 1 })
      setTableSortParams({})
      if (viewMode === VIEW_MODE.COLUMN) { fetchData() }
    }, [viewMode])

    useImperativeHandle(ref, () => ({
      batchAll,
      refresh
    }))
    return (
      <>
        <Affix offsetTop={64} target={() => document.body}>
          <BatchTools
            data={batchAll}
            visible={isBatch}
            onMove={() => {
              refresh()
              setIsBatch(false)
            }}
            onExport={() => setIsBatch(false)}
            onCancel={() => setIsBatch(false)}
          />
        </Affix>
        {component}
        {/* 瀑布流模式 */}
        <div className="mn-sample-content" style={style}>
          {viewMode === VIEW_MODE.PLAT ? (
            <MNWaterfallApi
              idKey="id"
              renderItem={Card.SampleCard}
              cardProps={{ isBatch, init: () => refresh(), containSubFolder: params?.containSubFolder }}
              url="/zhikuan/mn/sample/query-sample-info"
              method="post"
              params={params}
              ref={$masonry}
              onItemDataChange={(val) => {
                if (params.processParam) {
                  const _arr = String(params.processParam)
                    .split(',')
                    .map((item) => +item)
                  val.setData((pre) => {
                    const users = pre.filter((item) => {
                      if (_arr.length === 1) {
                        return _arr[0] === item.processId
                      }
                      if (_arr.length === 2) {
                        return _arr[0] === item.processId && _arr[1] === item.stepId
                      }
                      if (_arr.length === 3) {
                        // 待 和 中
                        return _arr[0] === item.processId && _arr[1] === item.stepId && _arr[2] === item.stepStatus
                      }
                      return true
                    })
                    return users
                  })
                } else {
                  val.setData((pre) => [...pre])
                }
              }}
              onTotal={(_total) => {
                onLoaded?.(_total)
              }}
              afterLoad={(_data) => {
                setBatchAll(_data)
              }}
              emptyText={<EmptyText />}
              emptyType="image"
            />
          ) : null}
        </div>
        {/* 表格渲染模式 */}
        {viewMode === VIEW_MODE.COLUMN ? (
          <div className={css.tableContainer} style={style}>
            <Loading spinning={loading}>
              {data?.resultList?.length ? (
                <SampleTable
                  isBatch={isBatch}
                  setIsBatch={setIsBatch}
                  data={data.resultList}
                  setParams={setTableSortParams}
                  containSubFolder={params.containSubFolder}
                  onChange={() => {
                    fetchData()
                  }}
                  onInit={() => fetchData()}
                  scroll={{ x: 0, y: document.body.clientHeight - 370 }}
                  accountInfo={userInfo}
                  teamInfo={teamInfo}
                />
              ) : (
                <Empty title={<EmptyText />} type="image" loading={loading} />
              )}
            </Loading>
            <div className="sample-pagination">
              <Pagination
                pageSize={pager.pageSize}
                pageNo={pager.pageNo}
                onChange={(_pageNo) => setPager({ pageNo: _pageNo, pageSize: pager.pageSize })}
                total={data?.resultCount}
                showQuickJumper={false}
              />
            </div>
          </div>
        ) : null}
      </>
    )
  }
)
export default SampleClothingList
